import { objectUtils } from '@/app/core/utils';
import { asContact, ClientContact, Contact } from '@ssar-app/domain';
import {
  Button,
  Icon,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Stack,
  Text,
} from '@chakra-ui/react';
import { AiOutlineDown } from 'react-icons/ai/index.js';
import { Fragment } from 'react';

export interface ContactPickerProps {
  contacts?: ClientContact[];
  inputContact?: Contact;
  contactType: string | ((contact: ClientContact) => boolean);
  onContactSelected: (contact: ClientContact) => void;
}

const ContactDetails = (props: {
  contact: ClientContact;
  isLastEntry: boolean;
}) => {
  const { contact } = props;
  // console.log(contact);
  return (
    <Stack px={5} direction={['row', 'column']} fontSize='sm'>
      <Text fontWeight='semibold'>{contact?.contactName}</Text>
      <Text>{contact?.contactEmail}</Text>
      <Text>
        {contact?.address1} <br />
        {contact?.city}, {contact?.state} - {contact?.zipCode}
      </Text>
      <Text>{contact?.entityName}</Text>
      {/* {!props.isLastEntry && <Divider />}
          {props.isLastEntry && <br />} */}
    </Stack>
  );
};

export const ContactPicker = (props: ContactPickerProps) => {
  const { contacts, contactType, onContactSelected } = props;
  const filteredContacts =
    typeof contactType === 'string'
      ? contacts?.filter(
          (a) => a.recordType?.toLowerCase() === contactType.toLowerCase(),
        ) || []
      : contacts?.filter(contactType) || [];
  const canShowDropdown = filteredContacts.length > 0;
  const selectedContacts: string[] = [];
  // console.log('Filtering');
  filteredContacts.forEach((clientContact, index) => {
    const contact = asContact(clientContact);
    if (
      props.inputContact &&
      objectUtils.areEqual(contact, props.inputContact, '_id')
    ) {
      selectedContacts.push(index.toString());
    }
  });

  const Contacts = () => {
    return (
      <MenuList>
        {filteredContacts?.map((contact, index) => (
          <Fragment key={index}>
            <MenuItem
              key={contact.contactName}
              onClick={() => {
                onContactSelected(contact);
              }}
              {...(selectedContacts.includes(index.toString())
                ? { background: 'gray.100' }
                : {})}
              h='full'
            >
              <ContactDetails
                contact={contact}
                isLastEntry={index === filteredContacts.length - 1}
              />
            </MenuItem>
            {index !== filteredContacts.length - 1 && (
              <MenuDivider color='gray.400' />
            )}
          </Fragment>
        ))}
      </MenuList>
    );
  };

  return (
    <Fragment>
      {canShowDropdown && (
        <Menu size='md' autoSelect={false} placement='bottom'>
          <MenuButton
            as={Button}
            colorScheme='blue'
            fontWeight='normal'
            rightIcon={<Icon as={AiOutlineDown} ml={4} />}
            height={'8'}
          >
            Select Contact
          </MenuButton>
          <Contacts />
        </Menu>
      )}
    </Fragment>
  );
};
